import request from '@/utils/request'
// import qs from 'qs'

// 官网文字列表
export const pageList = (getData) => {
  return request({
    url: '/back/official-website-text-editor/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
//官网文字单个详情
export const getId = (getData) => {
  return request({
    url: '/back/official-website-text-editor/getById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 删除
export const deleteById = (getData) => {
  return request({
    url: '/back/official-website-text-editor/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改
export const updateList = (postData) => {
  return request({
    url: '/back/official-website-text-editor/updateById',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增
export const addList = (postData) => {
  return request({
    url: 'back/official-website-text-editor/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
